__turbopack_context__.v({
  "hero": "loaderEdHero-module__PtmUTa__hero",
  "loaderSonarPulse": "loaderEdHero-module__PtmUTa__loaderSonarPulse",
  "ring": "loaderEdHero-module__PtmUTa__ring",
  "rippleLayer": "loaderEdHero-module__PtmUTa__rippleLayer",
});
